import React, { ComponentType, useEffect, useMemo } from 'react'
import { darkTheme, MeetingManager, MeetingProvider } from 'amazon-chime-sdk-component-library-react'
import { ConsoleLogger } from 'amazon-chime-sdk-js'
import { ThemeProvider as ScThemeProvider } from 'styled-components'
import staffModel from '@/core/models/staff.model'

type ChimeProviderProps = React.PropsWithChildren<{}>

export default function ChimeProvider(props: ChimeProviderProps) {
  const { children } = props

  const meetingManager = useMemo(() => new MeetingManager(new ConsoleLogger('ChimeProviderLogger')), [])

  useEffect(() => {
    meetingManager.getAttendee = async (chimeAttendeeId: string, externalUserId?: string) => {
      if (!externalUserId) return {}
      if (externalUserId.includes('MediaPipeline')) {
        return {
          name: 'MediaPipeline',
        }
      }
      try {
        const staff = await staffModel.getStaff(externalUserId)
        return {
          name: `${staff.userInfo.name} ${staff.userInfo.surname}`,
        }
      } catch {
        return {}
      }
    }
  }, [meetingManager])

  return (
    <MeetingProvider meetingManager={meetingManager}>
      <ScThemeProvider theme={darkTheme}>{children}</ScThemeProvider>
    </MeetingProvider>
  )
}

export function withChime<T extends object>(WrappedComponent: ComponentType<T>) {
  return (hocProps: T) => (
    <ChimeProvider>
      <WrappedComponent {...hocProps} />
    </ChimeProvider>
  )
}
